
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/features",
      function () {
        return require("private-next-pages/product/features.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/features"])
      });
    }
  